import styled from 'styled-components';
import { token } from '@bynder/design-system';

type StyledPreviewPopoverProps = {
	hasTransparentBackground?: boolean;
	imageRatio?: number;
};

const CHECKER_SIZE = '12px';

const checkeredBackground = `linear-gradient(
  45deg, ${token.gray100} 25%, transparent 25%, transparent 75%, ${token.gray100} 75%, ${token.gray100}), linear-gradient(
  45deg, ${token.gray100} 25%, transparent 25%, transparent 75%, ${token.gray100} 75%, ${token.gray100});`;

export const PreviewPopoverContainer = styled.div<StyledPreviewPopoverProps>`
	position: absolute;
	z-index: 10000;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 6px;
	background: ${(props) => props.hasTransparentBackground && checkeredBackground};
	background-color: ${token.white};
	background-size: calc(${CHECKER_SIZE} * 2) calc(${CHECKER_SIZE} * 2);
	background-position: 0 0, ${CHECKER_SIZE} ${CHECKER_SIZE};
	background-clip: padding-box;
	box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
	align-items: center;
	justify-content: center;
	padding: 9px;
	width: 200px;
	max-height: 150px;
	margin-left: -30px;
`;

export const PreviewPopoverArrow = styled.div<StyledPreviewPopoverProps>`
	position: absolute;
	display: block;
	width: 0;
	height: 0;
	border-style: solid;
	border-color: transparent;
	top: 50%;
	right: -22px;
	margin-top: -11px;
	border-right-width: 0;
	border-left-color: rgba(0, 0, 0, 0.25);
	border-width: 11px;
	&:after {
		position: absolute;
		display: block;
		width: 0;
		height: 0;
		border-style: solid;
		border-color: transparent;
		bottom: -10px;
		right: -9px;
		border-width: 10px;
		border-left-color: ${token.white};
		content: '';
	}
`;

export const PreviewImage = styled.img`
	max-width: 200px;
	max-height: 150px;
`;
